import * as React from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
    Button,
    CircularProgress,
    Grid,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Paper,
    PaperProps
} from "@mui/material";
import { useState } from "react";
import { useDataProvider, useRefresh } from "react-admin";
import { useForm } from "react-hook-form";
import ApiResources from "src/providers/ApiResources";
import { PackingList } from 'src/resources/sales/cards';
import Draggable from 'react-draggable';

interface ProcessingModalProps {
    action: any
    record: any;
    open: boolean;
    setOpen: any;
}

const PaperComponent = (props: PaperProps) => {
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}
  
export const ProcessingModal = (props: ProcessingModalProps) => {
    const { action, record, open, setOpen } = props;

    const [createShippment, setCreateShippment] = useState(false);
    const [loading, setLoading] = useState(false);
    const [submitError, setSubmitError] = useState(null);
    const { register, control, handleSubmit, getValues, setValue, setError, formState: { errors }} = useForm();
    const dataProvider = useDataProvider();
    const refresh = useRefresh();

    const executeAction = async (data) => {
        try {
            let formData = {...data};

            setLoading(true);
            setSubmitError(null);
            dataProvider
            .create(ApiResources.orderAction(record.id, action.id, false), {
                data: null,
            })
            .then((res) => {
                setLoading(false);
                refresh();
                setOpen(false);
            })
            .catch((error) => {
                setSubmitError(error.message);
                setLoading(false);
            });
        } catch (e) {
            console.log(e);
        }
    }

    return (
        <Dialog
            onClose={() => setOpen(false)}
            open={open}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
            fullWidth={true}
            maxWidth="sm"
        >
            <form onSubmit={handleSubmit(executeAction)}>
            <DialogTitle sx={{padding: "18px"}}>
                <Typography variant="body1" sx={{fontSize: "20px", fontWeight: "500"}}>Processing</Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => setOpen(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                    >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{padding: "18px !important"}}>
                <Grid container item sm={12} rowSpacing={1} columnSpacing={2}>
                    <Grid item sm={12}>
                        <Typography variant="button" sx={{marginBottom: "5px", display: "flex"}}>Packing List</Typography>
                        <PackingList record={record}/>                  
                    </Grid>

                    {/**
                    <Grid item sm={12} md={12}>
                        <FormControl>
                            <FormControlLabel control={
                                <Checkbox
                                value={createShippment}
                                onChange={(e) => setCreateShippment(!createShippment)}  
                            />
                            } label="Create Shippment?" />
                        </FormControl>
                    </Grid>
                    */}

                    { submitError &&
                    <Grid item sm={12} md={12} sx={{display: "flex", marginTop: "18px"}}>
                        <Typography variant="subtitle2" color="error">{submitError}</Typography>
                    </Grid>                     
                    } 
                </Grid>
            </DialogContent>
            <DialogActions sx={{padding: "18px"}}>
                <Button
                    variant="outlined"
                    onClick={() => {
                    setOpen(false);
                    }}
                >
                    Cancel
                </Button>
                <Button variant="contained" type="submit" disabled={loading}>
                    {loading && <CircularProgress size={18} thickness={2} sx={{ fontSize: "18px", color: "#ffffff", marginRight: "8px"}}/>}
                    Confirm
                </Button>
            </DialogActions>
            </form>
        </Dialog>
    );
};
